import IQuoteRecordAttributesBase from '../types/quoteRecordAttributesBase';

export const getOpenreachAddressAttrsBEnd = (attributes: IQuoteRecordAttributesBase): any => {
  return {
    id: '',
    type: 'talktalk_addresses',
    attributes: {
      alk: attributes.b_end_openreach_address?.full_site_alk || '',
      qualifier: attributes.b_end_openreach_address?.full_site_match_type || '',
      building_name: attributes.b_end_openreach_address?.full_site_building_name || '',
      building_number: attributes.b_end_openreach_address?.full_site_building_number || '',
      sub_building: attributes.b_end_openreach_address?.full_site_sub_building || '',
      street: attributes.b_end_openreach_address?.full_site_street || '',
      post_town: attributes.b_end_openreach_address?.full_site_town || '',
      county: attributes.b_end_openreach_address?.full_site_county || '',
      css_district_code: attributes.b_end_openreach_address?.full_site_district_code || '',
    },
  };
};
